/** Pure helpers for the V1 "Reorder Questions" button gate. */

/**
 * Whether the V1 "Reorder Questions" button should show: only in edit mode, only for
 * a V1 (non-sectioned) survey, and only when more than one question exists.
 */
export function shouldShowV1ReorderButton(args: {
	isEdit: boolean;
	surveyParts: Array<{ _type?: string }> | undefined;
	fields: Array<{ id?: string }>;
}): boolean {
	const hasV2Shape = (args.surveyParts ?? []).some(p => p?._type === 'SurveySection');
	if (hasV2Shape || !args.isEdit) return false;
	// Reorder is a local change persisted on Save, so any 2+ questions are reorderable —
	// including just-added (unsaved) ones. (Mirrors the V2 reorder-button gate.)
	return args.fields.filter(f => !!f.id).length > 1;
}
